<template>
  <!-- The global navbar already carries My CV / Careers / Standardization and
       Profile, so this shell adds no navigation of its own. -->
  <div class="dash tm-scope">
    <router-view />
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({});
</script>

<style scoped>
.dash {
  min-height: 100dvh;
  background: var(--tm-canvas);
}
</style>
